import { ReactElement } from "react";
import { IoCheckmark } from "react-icons/io5";
import { Icon } from "@chakra-ui/react";

const Checkmark = (): ReactElement => (
  <Icon mr={2.5} ml={2} h={4} w={3} color="white" as={IoCheckmark} />
);
export default Checkmark;
